import { IntercomProvider } from "@/libraries/intercom/src/provider";
import { HomePageTemplate } from "@/templates/home/home-page/src/home-page.template";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

export const HomePage = () => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = checkFeatureFlagGate(
        featureFlags.gwp737EnableIntercomChatHome
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <HomePageTemplate />
        </IntercomProvider>
    );
};
